const en_US :{[key: string]: string} = {
    login:'Login',
    email:'E-Mail',
    cachierDesk:'Cashier Desk',
    password:'Password',
    userNameNotNull: 'E-Mail cannot be empty',
    passwrodNotNull: 'Password cannot be empty',
    historyReport:'History',
    setting:'Settings',
    collectMoney:'Receive Money',
    amtNotNull: 'Amount cannout be empty',
    amtShouldBeNum:'Amount must be number',
    amtGreaterThan0:'Amount must greater than 0',
    amtShouldBeInteger: 'Amount can only be integer',
    amt: 'Amount',
    remark:'Remark',
    genQr:'Generate a QR code',
    scanQr:'Scan a QR code',
    collectQr:'Collect code',
    paySucc: 'Paid successfully',
    unpaid: 'Unpaid',
    modifyPass: 'Modify password',
    passLengthError: 'The length of password should greater than 6',
    passConfirmError: 'Two input password must be consistent',
    oldPass:'Old password',
    newPass: 'New password',
    confirmPass:'Confirm password',
    confirmModify: 'Confirm',
    transSucc: 'Success',
    newOrder:'New order',
    orderNo:'Order number',
    buyer: 'Buyer',
    payTime: 'Transaction time',
    finish: 'Finish',
    scanQrTips:'Scan automatically within the frame',
    lightOn: 'Light on',
    lightOff: 'Light off',
    logout:'Logout',
    confirmLogoutMsg:'Confirm to logout current account？',
    cancel: 'Cancel',
    confirm:'Confirm',
    languages: 'Languages',
    refunded:'Refunded',
    transFailed:'Failed',
    refunding: 'Refunding',
    refund: 'Refund',
    refundAmtLimit:'Refund amount cannot be greater than',
    canRefundAmt:'Refundable amount',
    refundAll:'Refund all',
    refundAmt:'Refund amount',
    report: 'Report',
    dayReport:'Daily report',
    overview:'Overview',
    transNum:'Number of transactions',
    fee: 'Fee',
    payment: 'Payment',
    orderDetail: 'Transaction detail',
    status:'Status',
    transactions:'Transactions',
    noData:'No data',
    noMore:'There\'s no more',
    storeName:'Store name',
    employeeName:'Employee name',
    employeeTitle:'Employee title',
    currency: 'Settle Currency',
    basicInfo:'Basic Information',
    keyError:'System error：the key is error',
    modifySucc:'Modify successfully!',
    refundSucc: 'Refund successfully!',
    SYSTEM_ERROR:'System is busy, please try again later',
    NETWORK_ERR: 'Network error, please check your network',
    chooseLan:'Choose a language',
    dealing:'Dealing...',
    transFailTips: 'Transaction failed，please take a new',

    /////////2018.10.10///////////
    forgetPassword: 'Forget password?',
    contactUs: 'Contact Us',
    contactTips: 'Input your E-mail, and we will contact you soon.',
    submit: 'Submit',
    contactSuccTips:'Submit successfully, we will contact you soon.',
    expireTime:'Expire at:',
    home: 'Home',
    bills: 'Checklist',
    my: 'my',
    partialRefunded: 'Refunded partially',
    returnLogin: 'Return to login',
    saveSucc: 'Save Successfully!',
    todayIncome: 'Today\'s Amount',
    todayTrans: 'Todays\'s Transactions',
    queryOrder:'Query order',
    cameraNotAuthorzied: 'Camera not authorized',
    camerarollDenied: 'Camera roll visit privacy not authorized',
    queryOrderTips: 'Please input the order number or scan the barcode of the transaction',
    loading: 'Loading...',
    ///===
    orderNoNotNull: 'Order number should not be empty.',
    oldPasswrodNotNull: 'Old password cannot be empty',
    newPasswrodNotNull: 'New password cannot be empty',
    confirmPasswrodNotNull: 'Confirm password cannot be empty',
    emailNotNull: 'Email cannot be empty',
    //=====2018.11.14====
    employeeManage: 'Employee manage',
    SUPER_ADMIN: 'Super Administrator',
    ADMIN: 'Store Administrator',
    // admin: 'Administrator',
    CASHIER: 'Cashier',
    modifyUser: 'Modify information',
    loginNo: 'Login Account',
    name: 'Name',
    phoneNumber: 'Phone number',
    role: 'Role',
    newUser: 'New user',
    add: 'Add',
    userBuyFee: 'User bears the fee',
    userBuyFee_checkout: 'User bears the fee',
    delete: 'Delete',
    pleaseInput: 'Please input',
    pleaseSelect: 'Please select',
    settlement: 'Settlement',
    allDate: 'All dates',
    settlementAmt:'Settle amount',
    merchantQr:'Merchant QR',
    clickView: 'Click to view',
    Alipay: 'Alipay',
    Wechat: 'Wechat',
    collectAmt: 'Pay Amount',
    collectNum: 'Payments received',
    refundNum: 'Payments refunded',
    orderList:'Transaction list',
    settlementDetail: 'Settlement detail',
    current: 'Current',
    scanBarcode: 'Scan Barcode',
    photos: 'Album',
    noQR: 'There\'s no QR code or barcode',
    deleteSucc: 'Delete successfully!',
    emailNoValid: 'E-mail not valid!',
    passwordLessThan6: 'Password length can\'t be less than 6!',
    ///=====
    settled: 'Settled',
    unSettled: 'Not settled',
    iSee: 'I see',
    unSettledTips: 'Fee has not been deducted from the Outstanding Balance, because we have to deal the Decimals when calculating. The final settlement shows the accurate fee amount.',
    voiceTip: 'Voice notification',
    //======
    exchangeRate: 'Exchange Rate',
    payCurrency: 'Trading Currency',
    markupRate: 'Increase Exchange Rate',
    modifyRate: 'Modify the ratio',
    confirmDeleteMsg:'Confirm to delete the user？',
    company: 'Company Name',
    contactPerson: 'Contact Person',
    //=====
    storeNotNull: 'Must select a store',
    allStore:'All Stores',
    turnOverLineTitle:'Turnover trend(7d)',
    merchantStatsTitle: 'Today\'s Turnover',
    turnover: 'Turnover',
    storeManagement: 'Store Management',
    collapse: 'Collapse',
    connected: 'Connected',
    disconnected: 'Disconnected',
    //====
    monthlyIncome: 'Monthly Amount',
    monthlyTradeNum: 'Montyly Transactions',
    collecting: 'You\'re collecting money: ',
    scanOrEnterPayQr: 'Please scan or enter user\'s pay qrcode',
    latestOrders: 'Latest Orders',
    more: 'More',
    cancelled: 'Cancelled',
    selectDate: 'Select dates',
    startDate: 'Start date',
    endDate: 'End date',
    settlementStatus: 'Settlement status',
    all: 'All',
    payType: 'Wallet',
    query: 'Query',
    export: 'Export',
    clear: 'Clear',
    unknown: 'Unknown',
    pagiPrefix: 'Display',
    pagiAfter: 'per page',
    settlementList: 'Settlement List',
    settlementDate: 'Settlement date',
    operations: 'Operations',
    downloadDetail: 'Download Details',
    merchantInfo: 'Merchant Information',
    country: 'Country/Region',
    storeType: 'Store type',
    SINGLE: 'Single store',
    CHAIN_STORE: 'Chain store',
    paymentSettings: 'Payment Settings',
    modify: 'Modify',
    download: 'Download',
    emialNotCorrect: 'Email is invalid',
    nameNotNull: 'Name cannot be empty',
    phoneNotCorrect: 'Phone number is invalid',
    lastLogin: 'Last login',
    deleteUser: 'Delete user',
    developerInfo: 'Developer Information',
    merchantName: 'Merchant name',
    merchantNo: 'Merchant No.',
    view: 'View',
    storeInfo: 'Store Information',
    storeId: 'Store ID',
    interfaces: 'Available Interfaces',
    online: 'Online',
    offline: 'Offline',
    webpage_api: 'Webpage Payment',
    app_api: 'APP Payment',
    barcode_api: 'Barcode Payment',
    transqr_api: 'Transaction Qrcode Payment',
    jsapi_api: 'JS API',
    dashboard: 'Dashboard',
    orders: 'Orders',
    settlements: 'Settlements',
    merchant: 'Merchant',
    info: 'Basic Information',
    account:'Account Information',
    users: 'Employees',
    developer: 'Developer',
    mustBeNumer:'Must by number',
    modifyPassSucc: 'Modify successfully, please login with your new password',
    addUserSucc: 'Add user successfully!',
    newOrderNoitf: 'New order, the amount is: ',
    unpaidToast: 'Waiting for paying, please confirm whether the user has completed the payment',
    queryOrderManually: 'Query order Manually',
    manualQueryOrderTips: 'Tips: Input or scan order No. to query the status of the order. You can use this feature when no notifications received when a user pays success.',
    findPassword: 'Find password by E-mail',
    findPasswordTips: 'Please fill your account, and then we\'ll send you an E-mail to give you directions to find your password back.',
    send: 'Send',
    backToLogin:'Back to login',
    resetPassword: 'Reset Password',
    resetPasswordTips: 'You\'re finding your password，please fill your E-mail and new password',
    sendSucc: 'Send successfully，please check the E-mail！',
    resetSucc: 'Reset successfully，please login with the new password！',
    reSendText: 'Resend after {sencond} seconds',
    msg404: 'Sorry，the page you\'re looking for is missing!',
    //====
    balance: 'Account balance',
    unsettled: 'Unsettled amount',
    minimum: 'Minimum withdrawal amount',
    minimumSettlementAmount:'Minimum settlement amount',
    settlementCurrency:'Settlement currency',
    withdrawal: 'Withdrawal amount',
    cash: 'Withdrawal',
    bank: 'Withdrawal bank',
    accountNumber: 'bank account',
    accountName: 'Bank account name',
    money: 'Withdrawal amount',
    cashToast: 'The amount of withdrawals must be greater than or equal to the minimum amount of withdrawals, less than or equal to the amount available.',
    collection: 'Collection',
	collectionLink: 'Collection link',
    createLink: 'CreateLink',
    storeChoose: 'Store selection',
    searchLink: 'SearchLink',
    copy: 'Copy',
    copySuccess: 'Copy succeeded',
    copyError: 'Failed to copy manually, please',
	transactionStatus: 'Transaction Status',
	paid: 'Paid',
	linkList: 'Link List',
    createTime: 'Creation time',
    payNo: 'Payment order number',
    partnerNo: 'Partner order number',
    linkDetail: 'Link details',
	exchangeManage: 'Exchange Manage',
	exchangeApply: 'Exchange Apply',
	exchangeRecords: 'Exchange Records',
	canExchangeAmount: 'Exchangeable Amount',
	salesAmount: 'Exchange Amount',
	buyingCurrency: 'Buying Currency',
	defaultBank: 'Use Default Bank Account Number',
	yes: 'YES',
	no: 'NO',
	bankName: 'Bank Name',
	bankNumber: 'Bank Account',
	bankAccName: 'Bank Account Name',
	bankAddress: 'Bank Address',
	swiftcode: 'Bank Swiftcode',
	exchangeDetail: 'Exchange Details',
	currentCurrency: 'Selling Currency',
	purchaseAmount: 'Purchase Amount',
	availableBalance: 'Available Balance',
	improveBankInformation: 'Please improve the bank information ！',
	sellToast: 'Please input the selling amount !',
	currencyToast: 'Please select currency ！',
	successTime: 'Success Time',
	exchangeSucc: 'Success',
	untreated: 'Untreated',
	functionToast: 'You have not yet enabled this feature ！'
}

export default en_US